import { Popup, Toast } from "antd-mobile";
import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { getText } from "../../../../utils/util";
import "./index.css";

export default function OrderPopup({
  nowTab,
  type,
  setType,
  isShowOrder,
  setIsShowOrder,
  coinListData,
  index,
  ctmarketlist,
  userInfo,
  buyCoin,
  hysetInfo,
  setyqsy,
}) {
  const navigate = useNavigate();
  const { t: translate } = useTranslation();
  const [type2, setType2] = useState(1);
  const [num, setNum] = useState<string | number>("");
  const [hyTimes, setHyTimes] = useState([]);
  const [hyTzeds, setHyTzeds] = useState([]);
  const [hyYkbls, setHyYkbls] = useState([]);
  let [minNum, setminNum] = useState(100);
  const [cykbl, setcykbl] = useState(100);
  const [isUse, setIsUse] = useState(true);
  //加载节点
  const getNodes = () => {
    if (!hyTimes) {
      return "";
    }
    const nodes = [];
    for (let index = 0; index < hyTimes.length; index++) {
      let hyTime = hyTimes[index];
      let hyTzed = hyTzeds[index];
      let cykbl = hyYkbls[index];
      const node = (
        <div
          className={
            type2 === index + 1
              ? "bg-primary/90 text-black rounded-lg p-2.5 m-1 flex flex-col items-center w-[60px]"
              : "bg-neutral-800 text-neutral-200 rounded-lg p-2.5 m-1 flex flex-col items-center border border-neutral-700 w-[60px]"
          }
          onClick={() => {
            setType2(index + 1);
            setminNum(hyTzed);
            // setNum(hyTzed);
            setcykbl(cykbl);
          }}
        >
          <div className="text-sm font-semibold">{hyTime}</div>
          <div className="text-xs mt-1">{cykbl}%</div>
        </div>
      );
      nodes.push(node);
    }
    return nodes;
  };

  const getName = (name) => {
    let name2 = nowTab.toUpperCase();
    for (const ctmarket of ctmarketlist) {
      if (name == ctmarket.coinname) {
        name2 =
          ctmarket.type === 2
            ? ctmarket?.issueName
            : ctmarket.coinname.toUpperCase();
        break;
      }
    }
    return name2;
  };

  useEffect(() => {
    setHyTimes(hysetInfo.hyTime);
    setHyTzeds(hysetInfo.hyTzed);
    setHyYkbls(hysetInfo.hyYkbl);
    setcykbl(hysetInfo.hyYkbl ? hysetInfo.hyYkbl[0] : 100);
    // setNum(hysetInfo.hyTzed ? hysetInfo.hyTzed[0] : 100);
    setminNum(hysetInfo.hyTzed ? hysetInfo.hyTzed[0] : 100);
  }, [hysetInfo]);

  const currentCoin = useMemo(() => {
    return ctmarketlist.find((v) => v.coinname === nowTab);
  }, [ctmarketlist, nowTab]);
  const coinname =
    currentCoin?.type === 2
      ? `${currentCoin.title}`
      : `${nowTab.toUpperCase()}/USDT`;

  return (
    <Popup
      visible={isShowOrder}
      onMaskClick={() => {
        setIsShowOrder(false);
      }}
      position="bottom"
      bodyStyle={{ width: "100vw", backgroundColor: "transparent" }}
    >
      <div className="revert-style bg-neutral-900 rounded-t-xl">
        <div className="flex justify-between items-center p-4 border-b border-neutral-700">
          <p className="text-white text-lg font-bold">
            {translate(getText("訂單確認"))}
          </p>
          <div
            className="w-6 h-6 bg-contain bg-no-repeat bg-center cursor-pointer"
            style={{
              backgroundImage:
                "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='white'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M6 18L18 6M6 6l12 12'%3E%3C/path%3E%3C/svg%3E\")",
            }}
            onClick={() => {
              setIsShowOrder(false);
            }}
          ></div>
        </div>
        <div className="p-4">
          <div className="bg-neutral-800 rounded-lg p-4 mb-4">
            <div className="flex justify-between items-center mb-3">
              <p className="text-neutral-400">{translate(getText("名稱"))}</p>
              <p className="text-white font-semibold">
                {getName(nowTab).toUpperCase()}
                <span className="text-neutral-400 ml-1">/USDT</span>
              </p>
            </div>
            <div className="flex justify-between items-center mb-3">
              <p className="text-neutral-400">{translate(getText("方向"))}</p>
              <p
                className={
                  type == 1
                    ? "text-success font-semibold"
                    : "text-danger font-semibold"
                }
              >
                {translate(getText(type == 1 ? "看漲" : "看跌"))}
              </p>
            </div>
            <div className="flex justify-between items-center">
              <p className="text-neutral-400">{translate(getText("現價"))}</p>
              <p className="text-white font-semibold">
                {coinListData[nowTab]?.close}
              </p>
            </div>
          </div>
          <div className="mb-4">
            <div className="overflow-x-auto">
              <div className="flex flex-nowrap justify-between">
                {getNodes()}
              </div>
            </div>
          </div>
          <div className="mb-6">
            <div className="mb-2">
              <p className="text-neutral-200 font-medium mb-1">
                {translate(getText("買入數量"))}
              </p>
            </div>
            <div className="mb-2">
              <input
                placeholder={translate(getText("最少10起買")).replace(
                  "10",
                  `${minNum}`
                )}
                className="w-full h-[45px] px-4 py-3 rounded bg-neutral-800/80 text-white focus:outline-none text-sm"
                type="number"
                min={minNum}
                step="0.01"
                name="num"
                value={num}
                onChange={(e) => {
                  // 将字符串转换为带两位小数的数字
                  const value = parseFloat(
                    parseFloat(e.target.value).toFixed(2)
                  );
                  setNum(value);
                  setTimeout(() => {
                    if (e.target.value && cykbl) {
                      setyqsy(value * cykbl * 0.01);
                    } else {
                      setyqsy(0);
                    }
                  }, 0);
                }}
              />
            </div>
            <div className="flex justify-between">
              <p className="text-neutral-400 text-sm">
                {translate(getText("可用餘額"))}:{userInfo?.usdt}
              </p>
              {/* <p className="text-neutral-400 text-sm">手續費:0%</p> */}
            </div>
          </div>
          <div>
            <button
              className="w-full h-[45px] rounded bg-gradient-primary text-black font-bold flex items-center justify-center text-base cursor-pointer"
              onClick={() => {
                if (Number(num) < minNum) {
                  Toast.show({
                    content: `${translate(getText("最低投資額"))} ${minNum}`,
                  });
                  return;
                }
                if (!isUse) {
                  return;
                }
                setIsUse(false);
                setTimeout(() => {
                  setIsUse(true);
                }, 3000);
                
                buyCoin({
                  ccoinname: coinname,
                  ctzed: num,
                  ctzfx: type,
                  ctime: hyTimes[type2 - 1].toUpperCase(),
                  cykbl: hyYkbls[type2 - 1],
                });
              }}
            >
              {translate(getText("確認下單"))}
            </button>
          </div>
        </div>
      </div>
    </Popup>
  );
}
